const MODALS = {
  PAID_PLAN: 'PAID_PLAN',
  LOGO_GENERATION: 'LOGO_GENERATION',
  LOGO_SEND: 'LOGO_SEND',
};

const PLANS = {
  FREE: 'FREE',
  PAID: 'PAID',
};

export { MODALS, PLANS };
